import * as React from 'react';
import {useCallback, useEffect} from 'react';
import {TopicModule} from '@/services/pages/channel/channel.client';
import {isWiseAgent} from '@/utils/utils';
import {VALUE_TYPE} from '@/dicts/consts';
import useJumpUrl from '@/hooks/useJumpUrl';
import {SELF_TOPIC_BAR_TYPE_ELLIPTICAL} from '@/dicts/modelConsts';
import {baseSendExposure} from '@/utils/logger/baseSendExposure';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}

const SelfTopicBottomBar = ({infos, page, channelBusinessLine}: Props) => {

    const {navigateToUrl} = useJumpUrl();

    const handleClick = useCallback(
        (linkUrl?: string, position?: string, button?) => {
            const urlParams = {
                linkUrl,
            };
            const logParams = {
                page: page,
                value: `jump_${position}_button`,
                channelId: infos?.channelId,
                pageType: channelBusinessLine,
                moduleId: infos?.moduleId,
                moduleName: button.fieldValue?.title,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: button.itemId,
                    // eslint-disable-next-line camelcase
                    value_title: button.fieldValue?.title,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [channelBusinessLine, infos?.channelId, infos.moduleId, page, navigateToUrl]
    );

    const initExposure = useCallback(
        // eslint-disable-next-line complexity
        (
            pageValue,
            pageSourceId,
            pageType,
            buttonList
        ) => {
            if (!pageValue || !pageSourceId || !pageType || buttonList.length < 1) {
                return;
            }
            // 底bar整体展现
            baseSendExposure({
                page: pageValue,
                value: 'topic_bottom_bar',
                pageSourceId: pageSourceId,
                pageType: pageType,
                valueId: infos.moduleId,
                valueTitle: infos.moduleName,
                valueType: VALUE_TYPE.MODULE,
            });
            // 单个按钮曝光 / 左侧按钮曝光
            baseSendExposure({
                page: pageValue,
                value: buttonList?.length === 2 ? 'jump_left_button' : 'jump_middle_button',
                pageSourceId: pageSourceId,
                pageType: pageType,
                valueId: buttonList[0].itemId,
                valueTitle: buttonList[0].fieldValue?.title,
                valueType: VALUE_TYPE.ITEM,
            });

            if (buttonList?.length === 2) {
                // 右侧按钮曝光
                baseSendExposure({
                    page: pageValue,
                    value: 'jump_right_button',
                    pageSourceId: pageSourceId,
                    pageType: pageType,
                    valueId: buttonList[1].itemId,
                    valueTitle: buttonList[1].fieldValue?.title,
                    valueType: VALUE_TYPE.ITEM,
                });
            }
        },
        [infos.moduleId, infos.moduleName]
    );

    // fix 底部bar无法自动曝光问题
    useEffect(
        () => {
            initExposure(page, infos.channelId, channelBusinessLine, infos.itemList);
        },
        [channelBusinessLine, infos, initExposure, page]
    );

    const renderContent = (info: TopicModule, prefixCls: string) => {
        return (
            <div className={styles[`${prefixCls}parent`]}>
                {
                    info.itemList && info.itemList.length >= 2
                        ? (
                            <div className={styles[`${prefixCls}content`]}>
                                <div
                                    className={styles[`${prefixCls}line`]}
                                />

                                <div
                                    className={styles[`${prefixCls}leftContent`]}
                                    onClick={() => {
                                        handleClick(
                                            info.itemList && info.itemList[0] ? info.itemList[0].fieldValue?.link : '',
                                            'left',
                                            info.itemList && info.itemList[0]
                                        );
                                    }}
                                    id="topic-bottomLeftBar"
                                >
                                    {
                                        info.itemList[0].fieldValue?.logo
                                            ? (
                                                <div
                                                    className={styles[`${prefixCls}logoContent`]}
                                                >
                                                    <img
                                                        src={info.itemList[0].fieldValue?.logo}
                                                        className={styles[`${prefixCls}logo`]}
                                                    />
                                                </div>
                                            )
                                            : null
                                    }

                                    <div
                                        className={styles[`${prefixCls}leftText`]}
                                    >
                                        {
                                            info.itemList[0].fieldValue?.title
                                        }
                                    </div>

                                </div>
                                <div className={styles[`${prefixCls}sepLine`]}></div>

                                <div
                                    className={styles[`${prefixCls}rightParent`]}
                                    onClick={() => {
                                        handleClick(
                                            info.itemList && info.itemList[1] ? info.itemList[1].fieldValue?.link : '',
                                            'right',
                                            info.itemList && info.itemList[1]
                                        );
                                    }}
                                    id="topic-bottomRightBar"
                                >
                                    {
                                        info.itemList[1].fieldValue?.title
                                    }
                                </div>

                            </div>
                        )
                        : info.itemList && info.itemList?.length > 0
                            ? (
                                <div
                                    className={styles(styles[`${prefixCls}content`], {
                                        [styles[`${prefixCls}contentPC`]]: !isWiseAgent(navigator.userAgent),
                                    })}
                                    onClick={() => {
                                        handleClick(
                                            info.itemList && info.itemList[0].fieldValue?.link,
                                            'middle',
                                            info.itemList && info.itemList[0]
                                        );
                                    }}
                                    id="topic-bottomMiddleBar"
                                >
                                    <div
                                        className={styles[`${prefixCls}line`]}
                                    />

                                    <div
                                        className={styles[`${prefixCls}rightParentMatch`]}
                                    >
                                        {
                                            info.itemList[0].fieldValue?.title
                                        }
                                    </div>

                                </div>
                            )
                            : null

                }
            </div>
        );
    };


    return (
        <div
            className={styles.bottomContainer}
        >
            {
                infos.moduleStyle === SELF_TOPIC_BAR_TYPE_ELLIPTICAL
                    ? renderContent(infos, 'elli')
                    : renderContent(infos, 'icon')
            }

        </div>
    );
};

export default SelfTopicBottomBar;
